import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import settingScheduleService from "../../../services/settingSchedule.service";
import ListItemDoc3 from "../../report/reportDoc3/listItemDoc3";

type paramType = {
  scheId: string;
  curriId: string;
};

const CourseListForSend = (props: { curri: any }) => {
  const params = useParams<paramType>();
  const { curri } = props;
  const [course, setCourse] = useState([]);

  useEffect(() => {
    (async () => {
      settingScheduleService.countCourse(Number(params.scheId)).then((res) => {
        if (res.data.length > 0) {
          setCourse(
            res.data.filter((x: any) => x.course.owner.id === curri.id)
          );
        }
      });
    })();
  }, []);

  return (
    <div>
      <table className="table table-hover table-responsive">
        <thead>
          <tr className="table-dark">
            <th>รหัสวิชา</th>
            <th>ชื่อวิชา</th>
            <th>หน่วยกิต</th>
            <th>อาจารย์ผู้รับผิดชอบรายวิชา</th>
            <th>กลุ่มเรียน</th>
            <th></th>
            <th>Handle</th>
          </tr>
        </thead>
        <tbody>
          {course.map((course: any) => {
            return <ListItemDoc3 key={course.id} data={course} />;
          })}

          {!(course.length > 0) && (
            <tr>
              <th colSpan={5}>
                <div className="text-danger">
                  <i className="bi bi-folder-x"></i>{" "}
                  ไม่พบรายวิชาที่ต้องส่งเอกสาร
                </div>
              </th>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default CourseListForSend;
